module.exports = __webpack_public_path__ + "img/service-banner4.f9ddb65b.png";